// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Lulk3943I4jCYbVIgYmG1"};